<template>
  <InternalLayout>
    <slot name="title">
      <h1 v-if="title" class="content__title heading">
        <div class="heading__start">
          <span>
            {{ title }}
            <Hint v-if="hint" :message="hint" />
          </span>
        </div>
      </h1>
    </slot>
    <p
      v-if="description"
      v-dompurify-html="description"
      class="content__description"
    />

    <slot />
  </InternalLayout>
</template>

<script>
import InternalLayout from '@@/common/layout/InternalLayout';
import Hint from '@@/common/Hint';

export default {
  name: 'Content',
  components: {
    InternalLayout,
    Hint,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.content {
  &__title {
    margin-bottom: 1rem;
    display: flex;
    align-items: flex-start;

    /* Typography */
    color: $wet-asphalt;
    font-size: rem-calc(25);

    &:not(.content__title--inline) {
      > h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        flex: 1;
      }
    }

    > h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: inherit;
      margin-bottom: 0;
    }
  }

  &__description {
    margin-top: $global-margin / 2;
    margin-bottom: $global-margin;

    color: rgba(0, 0, 0, 0.54);
  }
}
</style>
